import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage, FormattedRelative } from 'react-intl';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import styles from './styles/CartCustomHold.scss';

function CustomHold(props) {
    const { item } = props;
    const expirationDate = get(item, 'holds[0].expirationDate');

    return (
        <div className={styles.wrapper}>
            <div className={styles.message}>
                <FormattedMessage id="CartCustomHold.message" defaultMessage="On Hold For you" />
            </div>
            {expirationDate && (
                <span className={styles.countdown}>
                    <FormattedMessage
                        id="CartCustomHold.expires"
                        defaultMessage="Expires {expirationDate}"
                        values={{ expirationDate: <FormattedRelative value={expirationDate} /> }}
                    />
                </span>
            )}
        </div>
    );
}

CustomHold.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(CustomHold, {
    item: graphql`
        fragment CartCustomHold_item on Item {
            holds {
                expirationDate
            }
        }
    `,
});
